var lib_core = require("lib-core");

var ContentServerMetaData = function(name) {
    this.makeObservableTreeNode();

    this.name = this.value("name", true);
    this.summary = this.value("summary", true);
    this.description = this.value("description", true);
    this.tags = this.list("tags", true);
    this.alias = this.value("alias", true);

    if(name !== undefined) this.name(name);
};
lib_core.mixin(ContentServerMetaData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(ContentServerMetaData, "ContentServerMetaData");

module.exports = ContentServerMetaData;
